import { FC, ReactNode } from 'react'
import { IImport } from '../../../model/IImport'
import { IOnSort } from '../../hooks/usePagable'
import { icons } from '../../icons/IconSet'
import { IPagable } from '../../services/IPagable'
import Table, { ITableTh } from '../common/table/Table'
import ImportFiltersQuick from './ImportFiltersQuick'
import ImportsRow from './ImportsRow'

export interface IImportsList {
  title?: ReactNode
  imports?: IImport[]
  pagable?: IPagable
  isPending?: boolean
  loadTriggerComponent?: ReactNode
  onSort?: IOnSort
}

const ImportsList: FC<IImportsList> = ({
  title,
  pagable,
  imports,
  isPending = false,
  loadTriggerComponent,
  onSort,
}) => {
  const thead: ITableTh[] = [
    { title: ' ', align: 'center', sortCol: 'status' },
    // { title: ' ', align: 'center', sortCol: 'goalServer' },
    { title: '#', align: 'center', sortCol: 'productId' },
    {
      title: icons('clock-arrow-down', { width: '1.3em' }),
      align: 'center',
      sortCol: 'proccessPeriodMs',
    },
    { title: 'Name', align: 'center', sortCol: 'productName' },
    { title: '', align: 'center' },

    { title: icons('factory', { width: '1.3em' }), align: 'center', sortCol: 'company' },
    // { title: 'Price', align: 'center', sortCol: 'priceType' },
    // { title: 'Config', align: 'center', sortCol: 'configurationType' },
    {
      title: icons('calendar-arrow-down', { width: '1.3em' }),
      align: 'center',
      sortCol: 'createdAt',
    },
    { title: icons('calendar-arrow-up', { width: '1.3em' }), align: 'center', sortCol: 'sendedAt' },
    { title: 'Error', align: 'center' },
    { title: '', align: 'center' },
  ]

  return (
    <>
      <Table
        options={[
          <div className='flex gap-2'>
            <ImportFiltersQuick />
          </div>,
        ]}
        title={title}
        pagable={pagable}
        isPending={isPending}
        onSort={onSort}
        size='small'
        thead={thead}
        theadClassName=''
        trs={[...(imports || [])].map((imprt) => (
          <ImportsRow
            key={`row-${imprt.idImport}`}
            imprt={imprt}
          />
        ))}
      />
      {!!loadTriggerComponent && !isPending && loadTriggerComponent}
    </>
  )
}

export default ImportsList
